import { NavLink } from "react-router-dom";
import Load from "../../common/Loader/Load";

const RedeenNights = ({ hotels }) => {
  if (!hotels) {
    return <Load />;
  }

  return (
    <article className="redeem-hotels">
      <h1 className="redeem-hotels__title">Utiliza tu membresía</h1>

      <section className="redeem-hotels__grid">
        {hotels.map((hotel) => (
          <NavLink
            key={hotel.id}
            to={`/Solicitar/${hotel.id}/${hotel.titulo}`}
            className="hotel-card"
          >
            <img
              src={hotel.portada}
              alt={hotel.titulo}
              className="hotel-card__image"
            />

            <div className="hotel-card__info">
              <span className="hotel-card__name">{hotel.titulo}</span>

              <span className="hotel-card__city">{hotel.ciudad}</span>
            </div>
          </NavLink>
        ))}
      </section>
    </article>
  );
};

export default RedeenNights;
